import gql from "graphql-tag";
import CompanyIssuerFields from "lib/graphql/fragments/CompanyIssuerFields";

export default gql`
  query RelatedPeers($tickerSymbol: TickerSymbol!, $filterByVertical: PlatformVertical) {
    relatedPeers(tickerSymbol: $tickerSymbol, filterByVertical: $filterByVertical) {
      competitors {
        position
        exchangeId
        tickerSymbol
        issuer {
          ...CompanyIssuerFields
        }
      }
      industryPeers {
        position
        exchangeId
        tickerSymbol
        issuer {
          ...CompanyIssuerFields
        }
      }
      comparables {
        position
        exchangeId
        tickerSymbol
        issuer {
          ...CompanyIssuerFields
        }
      }
    }
  }

  ${CompanyIssuerFields}
`;
